import { MenuSection } from '@components/Sidebar/Menu/MenuSection';
import { routesPath } from '@router/routes';
import { prepareUrl } from '@utils/routerHelpers';

type QcRoute = {
  title: string;
  name: 'qcList' | 'qcQueries';
  path: string;
  icon: string;
};

export const qcRoutes: QcRoute[] = [
  {
    title: 'QC List',
    name: 'qcList',
    path: routesPath.qcTasks,
    icon: 'qc',
  },
  {
    title: 'Queries',
    name: 'qcQueries',
    path: routesPath.qcQueries,
    icon: 'puzzle',
  },
];

export const renderQcMenuSections = (
  clinicalTrialId: string | undefined,
  sidebarCollapsed: boolean
) =>
  qcRoutes.map((item, i) => {
    const path =
      item.name === 'qcQueries'
        ? prepareUrl(routesPath.qcQueries, [clinicalTrialId as string])
        : prepareUrl(routesPath.qcTasks, [clinicalTrialId as string]);

    return (
      <MenuSection
        item={{ ...item, path }}
        key={item.name}
        menuIndex={i}
        sideBarCollapsed={sidebarCollapsed}
      />
    );
  });
